import { getCustomSegmentSnippets } from '../pluginComponentApi';
export const getCustomSegmentTraits = async (projectId, version, labelColName) => {
  const customSegments = await getCustomSegmentSnippets(projectId, version);
  let options = [];
  if (customSegments && customSegments.data) {
    options.push({ value: '', name: '- Select Custom Segment -' });
    customSegments.data.forEach((item, key) => {
      options.push({ value: item.uuid, name: item.name });
    });
    return {
      type: 'select',
      label: labelColName,
      name: 'customSegmentUuid',
      changeProp: 1,
      options,
    };
  }
};
